
$(function () {
    if (window.__chatWithSalesPopupHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.chatWithSalesPopup = window.Branch.chatWithSalesPopup || {};
    window.Branch.chatWithSalesPopup.sliders = window.Branch.chatWithSalesPopup.sliders || {};
    window.__chatWithSalesPopupHasFired = true;

    function handleChatWithSalesOnClick(evt){
        let parent = evt.target.closest('.shopify-section')
        let parentId = parent.getAttribute('id');
        if(evt.target.closest('.chat-with-sales-button') && evt.target.closest('.chat-with-sales-button').getAttribute('data-type') != 'regular'){
            parentId = null;
        }
        let selector = `${parentId ? `#${parentId}` : ''} .chat-with-sales-popup${parentId ? '' : ':not([data-type="regular"])'}:last`;
        Simplistic.openModal($(`${selector}`), 'regular');
        return false;
    }

    function initChatWithSalesPopup(chatWithSalesPopupSection, parent){
        let parentId = chatWithSalesPopupSection.closest('.shopify-section') ? chatWithSalesPopupSection.closest('.shopify-section').getAttribute('id') : null;
        let selector = `${parentId ? `#${parentId}` : ''} .chat-with-sales-button${parentId ? '' : ':not([data-type="regular"])'}`;
        $(document).off('click', selector);
        $(`.tingle-modal-box__content .chat-with-sales-popup`).not(':last').remove();
        $(document).on('click', selector, handleChatWithSalesOnClick);

        let homepageHero = chatWithSalesPopupSection.classList.contains('homepage-hero__form-container');

        // Find forms within this specific section
        let $forms = $(chatWithSalesPopupSection).find('form');

        $forms.off('submit').submit(function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            var form = $(this);
            var error = false;
            
            form.parent().find('.error-msg').hide().text('');
            form.find('.error').removeClass('error');
            form.find('[aria-invalid]').removeAttr('aria-invalid');
        
            form.find('.required').each(function(){
            if($(this).val()=="") {
                error = true;
                $(this).addClass('error').attr('aria-invalid', 'true');
            }
            });
            if (!form.find(`input[name="contact[office]"]:checked`).val()) {
            error = true;
            form.find(`.radio-label`).addClass('error')
            form.find('input[name="contact[office]"]').attr('aria-invalid', 'true');
            } else {
            form.find(`.radio-label`).removeClass('error')
            }
            if(error){
                form.parent().find('.error-msg').show().text('Please complete all the required fields.');
                form.find('[aria-invalid="true"]').first().trigger('focus');
            }else{
            if(!Simplistic.validateEmail(form.find('input[name="contact[email]"]').val())) {
                error = true;
                form.find('input[name="contact[email]"]').addClass('error').attr('aria-invalid', 'true');
                form.parent().find('.error-msg').show().text('Please provide a valid email address.');
                form.find('[aria-invalid="true"]').first().trigger('focus');
            }
            }
        
            var name;
            var firstName;
            var lastName;
            if(form.find('input[name="contact[name]"]') && form.find('input[name="contact[lastname]"]')){
                firstName = (form.find('input[name="contact[name]"]').val() || '')
                lastName = (form.find('input[name="contact[lastname]"]').val() || '');
                name = `${firstName} ${lastName}`;
            } else {
                name = (form.find('input[name="contact[name]"]').val() || '').split(' ');
                firstName = name[0] || '';
                lastName = name[1] || '';
            }


            var variantId = $(`${parentId ? '#' : ''}${parentId}  .add-to-cart-form [name^=id]`).val();

            var variantName = window.Branch.product.variantNameMap[variantId] || '';
        
            function getHubSpotCookie() {
            const cookies = document.cookie.split(';');
            const hubspotCookie = cookies.find(cookie => cookie.trim().startsWith('hubspotutk='));
            return hubspotCookie ? hubspotCookie.trim().substring('hubspotutk='.length) : '';
            }
        
            if(!error) {
            var processAjax = function(arr, callback){
                var pending = arr.length;
                $.each(arr, function(){
                this.always(function(){
                    pending--;
                    if(pending==0) {
                    callback();
                    }
                });
                });
            };
            // Use different Hubspot form IDs based on form type
            var hubspotFormId = homepageHero
                ? '85bde8dd-a766-49f4-999b-48c7f5327061'  // Homepage hero form ID
                : 'b4d03787-24c5-48c6-bc05-0246fb80a152'; // B2B header form ID

            var ajaxHubspot = $.ajax({
                'url': 'https://api.hsforms.com/submissions/v3/integration/submit/5361087/' + hubspotFormId,
                'type': 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                fields: [
                    {name: 'referring_url', value: window.location.href || ''},
                    {name: 'referring_product_variant', value: variantName || ''},
                    {name: 'email', value: form.find('input[name="contact[email]"]').val() || ''},
                    {name: 'firstname', value: firstName || ''},
                    {name: 'lastname', value: lastName || ''},
                    {name: 'company', value: form.find('input[name="contact[company]"]').val() || ''},
                    {name: 'phone', value: form.find('input[name="contact[phone]"]').val() || ''},
                    {name: 'office_headcount', value: form.find('input[name="contact[office]"]:checked').val() || ''},
                    {name: 'message', value: form.find('textarea[name="contact[message]"]').val() || ''}
                ],
                context: {
                    hutk: getHubSpotCookie(),
                    pageUri: window.location.href,
                    pageName: document.title
                }
                })
            });
            processAjax([ajaxHubspot], function(){
                if(!homepageHero) {
                    form.parent().hide();
                    form.parent().parent().find('.success-msg').show().find('h2').trigger('focus');
                } else {
                    let formWrap = chatWithSalesPopupSection.closest('.shopify-section').querySelector('.form-wrap');
                    let overlay = chatWithSalesPopupSection.closest('.shopify-section').querySelector('.homepage-hero__form-overlay');

                    overlay.querySelector('.homepage-hero__form-overlay-input').style.display = 'none';
                    overlay.querySelector('.homepage-hero__form-overlay-cta').innerHTML = "Thank you! We'll be in touch";
                    overlay.querySelector('.homepage-hero__form-overlay-cta').setAttribute('data-click-through', 'empty form')

                    formWrap.setAttribute('data-visible', 'false');
                    setTimeout(() => {
                        overlay.style.removeProperty('height');
                        setTimeout(() => {
                            overlay.setAttribute('data-visible', 'true');
                            
                        }, 1);
                    }, 500);
                            
                }
            });
            }
        });
    }

function actionsOnVisible(chatWithSalesPopupSection, parent){
        chatWithSalesPopupSection.setAttribute('data-interacted', true);
        initChatWithSalesPopup(chatWithSalesPopupSection, parent);
    }    

function initChatWithSalesPopupCallback(chatWithSalesPopupSection, parent, type){
        let chatWithSalesPopupSectionParent = chatWithSalesPopupSection.closest('.shopify-section')
        let fromLoad = chatWithSalesPopupSection.closest('.homepage-content-container') && chatWithSalesPopupSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';
        if(type == 'fire-immediately'){
            actionsOnVisible(chatWithSalesPopupSection, null);
        } else if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(chatWithSalesPopupSection, parent);
        } else if(!chatWithSalesPopupSection.closest('.homepage-content-container')) {
            actionsOnVisible(chatWithSalesPopupSection, parent);
        } else if(chatWithSalesPopupSectionParent) {

            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = chatWithSalesPopupSectionParent.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                chatWithSalesPopupSection.getAttribute("data-interacted") !== "true"
            ) {
                
                actionsOnVisible(chatWithSalesPopupSection, parent);
                chatWithSalesPopupSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        } else {
            actionsOnVisible(chatWithSalesPopupSection, parent);
        }
    }

    window.Branch.chatWithSalesPopup.chatWithSalesPopupInitOnLoad = function(type){
        let chatWithSalesPopupSections = document.querySelectorAll('.chat-with-sales-popup:not(.chat-with-sales-popup-pdp):not([data-initialized="true"]), .homepage-hero__form-slider-container .homepage-hero__form-container:not([data-initialized="true"])');
        
        chatWithSalesPopupSections.forEach((chatWithSalesPopupSection) => {
            let currentType = type;
            let parent = chatWithSalesPopupSection.closest('.shopify-section');
            if(parent && parent.classList.contains('homepage-hero-section')){
                currentType = 'fire-immediately'
            }
            chatWithSalesPopupSection.setAttribute('data-initialized', true);
            if(parent){
                if(currentType == 'from-copy' || currentType == 'fire-immediately') {
                    initChatWithSalesPopupCallback(chatWithSalesPopupSection, parent, currentType)
                } 
                else {
                    window.Branch.functions.fireOnUserInteraction(initChatWithSalesPopupCallback, '.homepage-content-container', chatWithSalesPopupSection, chatWithSalesPopupSection, parent);
                }
            } else {
                initChatWithSalesPopupCallback(chatWithSalesPopupSection, null, 'fire-immediately')
            } 
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.chatWithSalesPopup.chatWithSalesPopupInitOnLoad('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.chatWithSalesPopup.chatWithSalesPopupInitOnLoad('regular'));
    }
  });

